    const Constants = {
        InformationBlock: {
            ContentRenderType: {
                Text: 'CONTENT_RENDER_TYPE_TEXT',
                Image: 'CONTENT_RENDER_TYPE_IMAGE',
                MultipleImage: 'CONTENT_RENDER_TYPE_MULTIPLE_IMAGES',
                MultipleTextAndImages: 'CONTENT_RENDER_TYPE_MULTIPLE_TEXT_AND_IMAGES',
                TextAndImage: 'CONTENT_RENDER_TYPE_TEXT_AND_IMAGE',
                Address: 'CONTENT_RENDER_TYPE_ADDRESS',
                Portfolio: 'CONTENT_RENDER_TYPE_PORTFOLIO',
                UserReview: 'CONTENT_RENDER_TYPE_USER_REVIEW',
                ProviderRecommendation: 'CONTENT_RENDER_TYPE_PROVIDER_RECOMMENDATION',
                Services: 'CONTENT_RENDER_TYPE_SERVICES',
                Members: 'CONTENT_RENDER_TYPE_MEMBERS',
                IG: 'CONTENT_RENDER_TYPE_IG',
                Bookables: 'CONTENT_RENDER_TYPE_BOOKABLES',
                Youtube: 'CONTENT_RENDER_TYPE_YOUTUBE'
            }
        }
    };

export default {
    methods: {
        isText(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.Text;
        },

        isImages(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.MultipleTextAndImages;
        },

        isPortfolio(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.Portfolio;
        },

        isAddress(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.Address;
        },

        isUserReview(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.UserReview;
        },

        isProviderRecommendation(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.ProviderRecommendation;
        },

        isServices(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.Services;
        },

        isBookables(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.Bookables;
        },

        isMembers(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.Members;
        },

        isTextAndImage(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.TextAndImage;
        },

        isIG(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.IG;
        },

        isYoutube(informationBlock) {
            return informationBlock
            && informationBlock.content_render_type === Constants.InformationBlock.ContentRenderType.Youtube;
        }
    }
}
